import { createClient } from '@supabase/supabase-js';

// Admin panel talks to Supabase ONLY through the server-side proxy at
// /api/proxy/*. The service role key never leaves the server.
//
// How it works:
//   1. supabase-js builds requests against a dummy URL.
//   2. Our custom fetch rewrites the URL from <dummy>/<path> to /api/proxy/<path>.
//   3. /api/proxy validates the admin token (from localStorage), substitutes
//      the service role key, and forwards to the real Supabase project.

const DUMMY_URL = 'https://admin-proxy.local';
const DUMMY_KEY = 'proxy';

const getAdminToken = () => {
  try {
    return localStorage.getItem('pg_admin_token') || '';
  } catch {
    return '';
  }
};

const proxyFetch = (input, init = {}) => {
  let url;
  let baseInit = init || {};
  if (typeof input === 'string') {
    url = input;
  } else if (input && typeof input === 'object' && 'url' in input) {
    url = input.url;
    baseInit = {
      method: input.method,
      headers: input.headers,
      body: input.body,
      ...init,
    };
  } else {
    return fetch(input, init);
  }

  if (!url.startsWith(DUMMY_URL)) {
    return fetch(input, init);
  }

  const suffix = url.slice(DUMMY_URL.length); // e.g. "/rest/v1/customers?select=*"
  const proxyUrl = '/api/proxy' + suffix;

  const headers = new Headers(baseInit.headers || {});
  headers.set('Authorization', `Bearer ${getAdminToken()}`);
  headers.delete('apikey');

  return fetch(proxyUrl, { ...baseInit, headers });
};

export const supabase = createClient(DUMMY_URL, DUMMY_KEY, {
  auth: { persistSession: false, autoRefreshToken: false },
  global: { fetch: proxyFetch },
});
